<div class="flex flex-row">
  <mat-form-field>
    <mat-select [(ngModel)]="eventType">
      <mat-option value="">Typ auswählen</mat-option>
      <mat-option value="contact">Kaufabsicht</mat-option>
      <mat-option value="scan">Scan</mat-option>
    </mat-select>
  </mat-form-field>
  <button mat-raised-button class="!bg-white m-3 self-start" (click)="openEventDialog()">
    <mat-icon>add</mat-icon> Event auslösen
  </button>
</div>
<div class="grow">
  <ag-grid-angular
    class="ag-theme-alpine w-full h-[calc(100vh-300px)]"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [rowData]="rowData$ | async"
    [rowSelection]="'multiple'"
    [animateRows]="true"
    [enableCellTextSelection]=true
    (cellDoubleClicked)="onCellDoubleClicked($event)"
    (cellEditingStopped)="onCellEditingStopped($event)"
    (gridReady)="onGridReady($event)"
  ></ag-grid-angular>
</div>
